import { MAX_ONLINE_ITEMS } from "../../../thor.const";
import { AddItemController } from "../../../sales/edit/add-item/add-item.controller";

export class AddOnlineItemController extends AddItemController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$scope",
        "$translate",
        "toaster",
        "utilsService"
    ];

    // Binded
    public container;
    public isMaxItemsReached: boolean;

    constructor(
        $log: ng.ILogService,
        $mdDialog: ng.material.IDialogService,
        $mdMedia: ng.material.IMedia,
        $scope: ng.IScope,
        $translate: ng.translate.ITranslateService,
        toaster,
        utils
    ) {
        super($log, $mdDialog, $mdMedia, $scope, $translate, toaster, utils);
    }

    public checkRestricted(event) {
        if (
            !this.container.isVoluntaryContractActivated ||
            !this.container.resource.datetime ||
            this.isMaxItemsReached
        ) {
            event.stopPropagation();

            if (!this.container.isVoluntaryContractActivated) {
                return this.toaster.show(
                    this.$t("merci_d_activer_votre_compte_stripe_volontaire_pour_creer_des_lots_online"),
                    true
                );
            }
            if (!this.container.resource.datetime) {
                return this.toaster.show(this.$t("no_sale_end_date_error"), true);
            }
            if (this.isMaxItemsReached) {
                return this.toaster.show(this.$t("max_items_add_error", [MAX_ONLINE_ITEMS]), true);
            }
        }
    }

    protected createNewItemDialog() {
        this.$mdDialog.show({
            controller: "NewOnlineItemDialogController",
            controllerAs: "newOnlineItemDialogCtrl",
            template: require("./new-item-dialog.html"),
            locals: {
                container: this.container
            },
            bindToController: true,
            fullscreen: this.$mdMedia("xs")
        });
    }

    protected _createUploadDialog(event, data, engineType) {
        this.$mdDialog.show({
            controller: "ImportOnlineDialogController",
            controllerAs: "importDialogCtrl",
            template: require("./import-online-dialog.html"),
            locals: {
                container: this.container,
                engineData: data,
                engineType: engineType
            },
            bindToController: true,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: this.$mdMedia("xs")
        });
    }
}
